import { AQUAPOD_YIELD, computeAnnualCapacity } from './aquapodCalculations.js';

export const sumEnabledVolume = (items) => items.filter(it => it.enabled).reduce((sum, it) => sum + (it.volume || 0), 0);

/**
 * Volume annuel réellement valorisable pour un modèle Aquapod donné : le plus petit des trois
 * plafonds — gisement collecté après pertes de traitement (rendement 80%), besoin réel des
 * usages cochés, et capacité de traitement annuelle du modèle (débit journalier × 365).
 */
export const computeValorizedVolume = (gisementVolume, besoinVolume, model) => {
  const treatable = gisementVolume * AQUAPOD_YIELD;
  const capacity = computeAnnualCapacity(model);
  return Math.max(0, Math.min(treatable, besoinVolume, capacity));
};

/**
 * @returns {Object[]} pour chaque modèle Aquapod, le volume valorisable et le facteur limitant
 *   (gisement, besoin ou capacité machine) — sert au tableau de choix de l'étape Bilan.
 */
export const evaluateModels = (models, gisementVolume, besoinVolume) => models.map(model => {
  const treatable = gisementVolume * AQUAPOD_YIELD;
  const capacity = computeAnnualCapacity(model);
  const valorized = computeValorizedVolume(gisementVolume, besoinVolume, model);

  let limitingFactor = 'capacité';
  if (valorized === treatable) limitingFactor = 'gisement';
  else if (valorized === besoinVolume) limitingFactor = 'besoin';

  return { model, capacity, valorized, limitingFactor };
});

/**
 * Modèle recommandé : le plus petit (donc le moins cher) parmi ceux dont la capacité ne
 * bride pas la valorisation par rapport au gisement/besoin — à défaut, le plus grand modèle
 * disponible (celui qui valorise le plus, même s'il reste bridé par sa propre capacité).
 */
export const recommendModel = (evaluations) => {
  const unconstrained = evaluations.filter(e => e.limitingFactor !== 'capacité');
  if (unconstrained.length > 0) {
    return unconstrained.reduce((a, b) => (a.model.dailyCapacityM3 <= b.model.dailyCapacityM3 ? a : b));
  }
  return evaluations.reduce((a, b) => (b.valorized > a.valorized ? b : a));
};
